import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import PostBcVasStepsContainer from "../post-bc-vas-steps-container/component";
import icon from "./images/tick-icon.png";
import { HUDDLE_STATUS } from "../../au.mobile/post-payment-journey/constant";

const ExploreInsurancePlanCard = ({ heading, slideData, redirectingSubTitle = "", redirectedSubTitle = "", failedData, isSubmitLoading, formData }) => {
    const isInsuranceFailed = formData?.status === HUDDLE_STATUS.FAILED;
    const { title: failedTitle = "", redirectedSubTitle: failedSubTitle = "" } = failedData || {};

    const getSubTitle = () => {
        if (isSubmitLoading) {
            return redirectingSubTitle;
        }

        if (isInsuranceFailed) {
            return failedSubTitle;
        }

        return redirectedSubTitle;
    };

    return (
        <div styleName={"styles.outerContainer"}>
            <div styleName={"styles.topImageWrapper"}>
                {isSubmitLoading ? <div styleName={"styles.spinnerInsure"} /> : <img src={icon} width={40} height={40} alt="Icon" />}
            </div>
            <div styleName={"styles.contentWrap"}>
                <p styleName={"styles.heading"}>{isInsuranceFailed ? failedTitle : heading}</p>
                <p styleName={"styles.subHeading"}>{getSubTitle()}</p>

                {!isInsuranceFailed && <div styleName={"styles.stepsWrapper"}>
                    {slideData.map((el, index) => (
                        <PostBcVasStepsContainer key={index} stepsImage={el.iconUrl} text={el.text} />
                    ))}
                </div>}
            </div>
        </div>
    );
};

ExploreInsurancePlanCard.propTypes = {
    bannerImage: PropTypes.string,
    heading: PropTypes.string,
    slideData: PropTypes.array,
    showUpNext: PropTypes.bool,
    redirectingSubTitle: PropTypes.string,
    formData: PropTypes.object,
    redirectedSubTitle: PropTypes.string,
    isSubmitLoading: PropTypes.bool,
    setIsSubmitLoading: PropTypes.bool,
    failedData: PropTypes.object
};

export default ExploreInsurancePlanCard;
